module.exports = __webpack_public_path__ + "fonts/PT-Mono-Regular.6bb33c8.ttf";